import React, { useEffect, useMemo } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { Box } from "@mui/material";

import Loading from "../../components/Loading";
import Wrapper from "../../components/Login/Wrapper";
import { useBranding } from "../../hooks";
import { useApiOptions } from "../../hooks/DataFetching";
import { useRootHttpRequest } from "../../services/api";
import { useAuth } from "../../utils/AuthProvider";

const LoginPage = () => {
  const branding = useBranding();
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { axiosInstance: rootApiClient } = useRootHttpRequest();
  const { data: apiOptions, isLoading } = useApiOptions({ apiClient: rootApiClient });

  useEffect(() => {
    if (auth.isAuthenticated) navigate("/", { replace: true });
  }, [auth, navigate]);

  const backgroundURL = useMemo(() => {
    if (!isLoading && apiOptions?.background) {
      return apiOptions?.background;
    } else {
      return branding.assets.loginBg;
    }
  }, [apiOptions, branding, isLoading]);

  return auth.isAuthenticated === false && branding && backgroundURL ? (
    <Box
      sx={{
        height: window.innerHeight,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: backgroundURL && !isLoading ? `url(${backgroundURL})` : "",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Wrapper>
        <Outlet />
      </Wrapper>
    </Box>
  ) : (
    <Loading />
  );
};
export default LoginPage;
